module.exports = __webpack_public_path__ + "static/img/X智慧云平台.bcd7b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-2-model/X智慧云平台.png
// module id = rEMS
// module chunks = 0